import { DocumentState, DocumentTypes, DocumentActionTypes } from './types'
import { Reducer } from 'redux'

const initialState: DocumentState = {
  documents: []
}

type ReducerOpts = Reducer<DocumentState, DocumentActionTypes>
const reducer: ReducerOpts = (state = initialState, action: DocumentActionTypes): DocumentState => {
  let index = -1
  switch (action.type) {
    case DocumentTypes.DOCUMENT_CREATE:
      return { ...state, documents: [...state.documents, action.payload] }
    case DocumentTypes.DOCUMENT_UPDATE:
      index = state.documents.findIndex(obj => obj.id === action.payload.id)
      return {
        ...state,
        documents: [
          ...state.documents.slice(0, index),
          action.payload,
          ...state.documents.slice(index + 1)
        ]
      }
    case DocumentTypes.DOCUMENT_DELETE:
      index = state.documents.findIndex(obj => obj.id === action.payload)
      return {
        ...state,
        documents: [
          ...state.documents.slice(0, index),
          ...state.documents.slice(index + 1)
        ]
      }
    case DocumentTypes.DOCUMENT_GET:
      return { ...state, document: action.payload }
    case DocumentTypes.DOCUMENT_GET_LIST:
      return { ...state, documents: action.payload }
    default:
      return state
  }
}

export default reducer
